var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2351_3022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5763 7.52876C13.7013 7.65378 13.7715 7.82332 13.7715 8.0001C13.7715 8.17687 13.7013 8.34641 13.5763 8.47143L9.80496 12.2428C9.74346 12.3064 9.6699 12.3572 9.58856 12.3922C9.50723 12.4271 9.41975 12.4455 9.33123 12.4463C9.24271 12.447 9.15492 12.4302 9.07299 12.3966C8.99106 12.3631 8.91663 12.3136 8.85403 12.251C8.79144 12.1884 8.74193 12.114 8.70841 12.0321C8.67489 11.9501 8.65802 11.8623 8.65879 11.7738C8.65956 11.6853 8.67795 11.5978 8.71289 11.5165C8.74783 11.4352 8.79862 11.3616 8.86229 11.3001L11.4956 8.66676H2.66696C2.49015 8.66676 2.32058 8.59653 2.19555 8.4715C2.07053 8.34648 2.00029 8.17691 2.00029 8.0001C2.00029 7.82329 2.07053 7.65372 2.19555 7.52869C2.32058 7.40367 2.49015 7.33343 2.66696 7.33343H11.4956L8.86229 4.7001C8.74085 4.57436 8.67366 4.40596 8.67518 4.23116C8.6767 4.05637 8.74681 3.88916 8.87041 3.76555C8.99402 3.64195 9.16123 3.57183 9.33603 3.57031C9.51082 3.56879 9.67922 3.63599 9.80496 3.75743L13.5763 7.52876Z",
    fill: "#785607"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2351_3022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 -1 -1 0 16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLine);
export default __webpack_public_path__ + "static/media/arrow-up-line.34aa13672133a460a2641d793859edb1.svg";
export { ForwardRef as ReactComponent };